module.exports = __webpack_public_path__ + "img/changer-poster-before.499cd7c9.jpg";